import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHomeCityStart,
  getHomeCitySuccess,
  getHomeCityFailure,
} from "../reducers/getHomeCityReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHomeCity = createAsyncThunk(
  "getHomeCity",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHomeCityStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Home/GetCity`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHomeCitySuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHomeCityFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
